<template>
  <v-layout>
    <div class="padding-container-lg">
      <v-page-header>
        <!-- <span slot="header">
          <h4>Edit care plan</h4>
        </span> -->
        <template
          v-if="carePlan"
          slot="subHead"
        >
          Care ID - {{ carePlan.plan_no }}
        </template>
      </v-page-header>
      <div v-if="carePlan">
        <v-edit-care-plan
          @onSubmit="onSubmit"
          :carePlan="carePlan"
          type="edit"
        />
      </div>
      <template v-if="carePlan">
        <v-accordion
          v-if="careplanIntervention"
          :module="modules.intervene"
          :data="careplanIntervention"
        />
        <v-accordion
          v-if="careplanAssessment"
          :module="modules.assessment"
          :data="careplanAssessment"
        />
        <v-accordion
          v-if="careplanInstruction"
          :module="modules.instruction"
          :data="careplanInstruction"
        />
      </template>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '@/layouts/Default.vue';
import VEditCarePlan from '@/components/careplan/Modify.vue';
import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VAccordion from '@/components/careplan/Accordion.vue';
import { mapGetters } from 'vuex';
import careplan from '@/mixins/careplan';
import modules from '../_modules';

export default {
  name: 'EditCareplan',
  components: {
    VEditCarePlan,
    VLayout,
    VPageHeader,
    VAccordion
  },
  mixins: [careplan],
  data() {
    return {
      carePlan: null,
      modules
    };
  },
  computed: {
    ...mapGetters({
      computedCarePlan: 'careplan/getCareplan',
      intervention: 'careplan/getIntervention',
      assessment: 'careplan/getAssessment',
      instruction: 'careplan/getInstruction'
    }),
    careplanIntervention() {
      return {
        name: 'Prescriptions',
        index: 1,
        isEdit: true,
        module: modules.intervene,
        list: this.intervention,
        onCreate: data => this.$store.dispatch(
          'careplan/createIntervention',
          { id: this.carePlan.id, data }
        ),
        onUpdate: data => this.$store.dispatch(
          'careplan/updateIntervention',
          { id: data.id, data }
        ),
        defaultProps: {
          careplan_id: '',
          total_days: 0,
          skip_days: '',
          name: '',
          frequency: null,
          color: '#00759A',
          dosage: '',
          instructions: '',
          category_id: ''
        }
      };
    },
    careplanAssessment() {
      return {
        name: 'Side Effects/Symptoms',
        index: 2,
        isEdit: true,
        module: modules.assessment,
        list: this.assessment,
        onCreate: data => this.$store.dispatch(
          'careplan/createAssessment',
          { id: this.carePlan.id, data }
        ),
        onUpdate: data => this.$store.dispatch(
          'careplan/updateAssessment',
          { id: data.id, data }
        ),
        defaultProps: {
          name: '',
          min: '',
          max: '',
          threshold: '',
          label_min: '',
          label_max: '',
          careplan_id: '',
          target_or_time: '',
          start_time: '',
          end_time: '',
          prompt_time: '',
          input_type: '',
          question: ''
        }
      };
    },
    careplanInstruction() {
      return {
        name: 'Note Instruction',
        index: 3,
        module: modules.instruction,
        isEdit: true,
        list: this.instruction,
        onCreate: data => this.$store.dispatch(
          'careplan/createInstruction',
          { id: this.carePlan.id, data }
        ),
        onUpdate: data => this.$store.dispatch(
          'careplan/updateInstruction',
          { id: data.id, data }
        ),
        defaultProps: {
          title: '',
          label: '',
          instructions: '',
          careplan_id: ''
        }
      };
    }
  },
  watch: {
    computedCarePlan: 'setCarePlan'
  },
  beforeMount() {
    this.$store.dispatch('careplan/view', this.$route.params.id);
  },
  methods: {
    onSubmit(data) {
      this.$store.dispatch('careplan/update', { data, id: data.id });
    },
    setCarePlan(value) {
      const carePlan = this.clone(value);
      carePlan.plan_start_date = this.getFormattedDate(carePlan.plan_start_date);
      this.carePlan = carePlan;
    },
    calculateList() {
      const list = [];
      let i;
      for (i = 0; i < 30; i += 1) {
        list.push({
          name: 'STIVARGA/medicine',
          subText: '(40mg)',
          times: `${i + 1} times`,
          color: `#${
            Math.random()
              .toString(16)
              .slice(2, 8)}`
        });
      }
      return list;
    }
  }
};

</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
